// extracted by mini-css-extract-plugin
export default {"loader":"SvgIcon_loader__ntoXp","spin":"SvgIcon_spin__0twIk"};